import config from "../../config/config.json";
import { getHeaders } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../APIHelpers/Responses";

export const twoFactorAuthServices = {
  generateQRCode,
  getQRData,
  showQRCode,
  enableTwoFactorAuth,
  disableTwoFactorAuth,
  twoFactorAuthType,
  getTwoFactorAuthType,
  emailOTPFor2FA,
  enableTwoFactorAuthByEmail,
  disableTwoFactorAuthByEmail,
  checkQRCode,
  verifyTwoFAForAppLogin,
  verifyTwoFAForEmailLogin,
};

// Get Auth Type
async function getTwoFactorAuthType(auth) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getTwoFactorAuthType`,
    headersWithAuthWithoutBody("GET", getHeaders(auth))
  );
  const data = await response.json();
  return data;
}

// Update Auth Type
async function twoFactorAuthType(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}twoFactorAuthType`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const data = await response.json();
  if (data?.statusCode === 401) {
    handleResponse(data)
  }
  return data;
}

// Generate QR code
async function generateQRCode(auth) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}generateQRCode`,
    headersWithAuthWithoutBody("GET", getHeaders(auth))
  );
  const data = await response.json();
  return data;
}

// Show QR code
async function showQRCode(auth) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}showQRCode`,
    headersWithAuthWithoutBody("GET", getHeaders(auth))
  );
  const data = await response.json();
  return data;
}

// Check QR & OTP
async function checkQRCode(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}checkQRCode`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Enable Two Factor Auth 
async function enableTwoFactorAuth(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}enableTwoFactorAuth`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Disable Two Factor Auth 
async function disableTwoFactorAuth(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}disableTwoFactorAuth`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get QR Data
async function getQRData(auth) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getQRData`,
    headersWithAuthWithoutBody("GET", getHeaders(auth))
  );
  const data = await response.json();
  return data;
}

// Send OTP for Email two factor auth
async function emailOTPFor2FA(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}emailOTPFor2FA`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Enable Email Two Factor Auth 
async function enableTwoFactorAuthByEmail(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}enableTwoFactorAuthByEmail`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Disable Email Two Factor Auth 
async function disableTwoFactorAuthByEmail(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}disableTwoFactorAuthByEmail`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Verify Two FA for App Login
async function verifyTwoFAForAppLogin(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}verifyTwoFAForAppLogin`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Verify Two FA for Email Login
async function verifyTwoFAForEmailLogin(auth, userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}verifyTwoFAForEmailLogin`,
    headersWithAuth("PUT", userData, getHeaders(auth))
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}